import React, {useEffect} from "react";
import Button from "../ui-components/Button";
import Select from "../ui-components/Select";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import ServiceConfiguratorBlockSpreadsheetInputMapping from "./ServiceConfiguratorBlockSpreadsheetInputMapping";
import ServiceConfiguratorBlockSpreadsheetOutputRanges from "./ServiceConfiguratorBlockSpreadsheetOutputRanges";
import {useSpreadsheets} from "../feature/spreadsheets/hooks/useSpreadsheets";

const DEFAULT_OUTPUT_OBJ = {
  spreadsheet_id: null,
  spreadsheet_name: null,
  sheets: [],
  input_mapping: {},
  output_ranges: []
};


const ServiceConfiguratorBlockCalculationSpreadsheetGenerator = ({
  spreadsheetConfiguration,
  updateSpreadsheetConfiguration,
  questions,
  recursiveQuestions,
  setSelectedOperator,
  editable=true,
  ...rest
}) => {


  const spreadsheetConfigurationObject = spreadsheetConfiguration === "spreadsheet"
    ? {...DEFAULT_OUTPUT_OBJ, original: spreadsheetConfiguration}
    : JSON.parse(spreadsheetConfiguration);
  const {spreadsheets, loading} = useSpreadsheets()
  useEffect(() => {
    if (editable && spreadsheets?.length > 0 && !spreadsheetConfigurationObject.spreadsheet_id) {
      updateSpreadsheetConfiguration({
        ...spreadsheetConfigurationObject,
        spreadsheet_id: spreadsheets[0].spreadsheet_id,
        spreadsheet_name: spreadsheets[0].spreadsheet_name,
        output_ranges: spreadsheets[0].output_ranges,
        sheets: spreadsheets[0].sheets,
        input_mapping: {},
      })
    }
  }, [spreadsheets])
  const filterQuestionsByInputType = (type) => questions
    .filter((q) => q.input_type === type)
    .map((q) => ({
      name: q.name || `Question ${q.id}`,
      value: q.id,
    }));

  return (
    <div className="flex flex-col w-full mb-8 mt-8">
      <div className=" mb-2 flex text-center justify-center">
        <p className="font-bold">Spreadsheet configurator</p>
      </div>
      {spreadsheets?.length && <Select
        label={"Select spreadsheet"}
        options={spreadsheets.map((s) => ({
          name: s.spreadsheet_name,
          value: s.spreadsheet_id,
        }))}
        value={spreadsheetConfigurationObject.spreadsheet_id || ""}
        onChange={(e) =>
          updateSpreadsheetConfiguration({
            ...spreadsheetConfigurationObject,
            spreadsheet_id: e.target.value,
            spreadsheet_name: spreadsheets.find((s) => s.spreadsheet_id === e.target.value).spreadsheet_name,
            output_ranges: spreadsheets.find((s) => s.spreadsheet_id === e.target.value).output_ranges,
            sheets: spreadsheets.find((s) => s.spreadsheet_id === e.target.value).sheets,
            input_mapping: {},
          })
        }
        disabled={!editable}
      />}
      <ServiceConfiguratorBlockSpreadsheetInputMapping
        spreadsheetConfigurationObject={spreadsheetConfigurationObject}
        updateSpreadsheetConfiguration={updateSpreadsheetConfiguration}
        questions={questions}
        recursiveQuestions={recursiveQuestions}
        editable={editable}
        {...rest}
        />
      <ServiceConfiguratorBlockSpreadsheetOutputRanges
        spreadsheetConfigurationObject={spreadsheetConfigurationObject}
        updateSpreadsheetConfiguration={updateSpreadsheetConfiguration}
        questions={questions}
        recursiveQuestions={recursiveQuestions}
        editable={editable}
        {...rest}
      />
      {editable && <div className="mt-4 flex justify-end">
        <Button onClick={() => setSelectedOperator(null)}>DONE</Button>
      </div>}
    </div>
  );
};

export default ServiceConfiguratorBlockCalculationSpreadsheetGenerator;
